import styles from "../opsDashboard.module.css";
import type { BadgeTone } from "../opsDashboard.types";

const TONE: Record<BadgeTone, string> = {
    neutral: styles.toneNeutral,
    brand: styles.toneBrand,
    indigo: styles.toneIndigo,
    success: styles.toneSuccess,
    warning: styles.toneWarning,
    danger: styles.toneDanger,
    info: styles.toneInfo,
};

/** Design system Badge, uppercase variant — the only one the dashboard uses. */
export function Badge({ tone, children }: { tone: BadgeTone; children: React.ReactNode }) {
    return <span className={`${styles.badge} ${TONE[tone] ?? TONE.neutral}`}>{children}</span>;
}
